import { render, staticRenderFns } from "./oidc-silent-renew-page.vue?vue&type=template&id=5792c8bd&"
import script from "./oidc-silent-renew-page.vue?vue&type=script&lang=js&"
export * from "./oidc-silent-renew-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports